export enum CompanyCardStatus {
    Online = "Online",
    Offline = "Offline",
    Inactive = "Inactive",
    Deactivated = "Deactivated",
}